import { useState } from "react";
import type { Event } from "@/types";
import { useBackgroundImage } from "@/hooks/useBackgroundImage";
import { BackgroundImage } from "@/components/home/BackgroundImage";
import { ContentSection } from "@/components/home/ContentSection";

// Direct background image URLs
const BACKGROUND_IMAGES = [
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/dancing_women_2.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/dancing_women.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_girl_2.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_girl.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_grou2.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_group.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_guy_girl.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_women2.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_women3.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Festival_women.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/festival_women_solo.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/man_x2_shirtless.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub1.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub2.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub3.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub4.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub5.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub6.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub7.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/Nightclub8.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/party_group_2.jpg",
  "https://ehskmwgoablwyqevwegt.supabase.co/storage/v1/object/public/images/Stock_Images/party_group.jpg"
];

// Fisher-Yates shuffle algorithm to randomize array order - kept for future use
const shuffleArray = (array: any[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const Index = () => {
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const { backgroundImage, isLoadingImage } = useBackgroundImage(BACKGROUND_IMAGES);

  // Function to handle event selection for the modal
  const handleEventSelect = (event: Event) => {
    setSelectedEvent(event);
    setModalOpen(true);
  };

  return (
    <div className="min-h-screen overflow-hidden relative">
      {/* Background image with lowest z-index */}
      <BackgroundImage 
        backgroundImage={backgroundImage}
        isLoadingImage={isLoadingImage}
      />
      
      {/* Content section with z-index 20 */}
      <ContentSection 
        backgroundImages={BACKGROUND_IMAGES}
        selectedEvent={selectedEvent}
        modalOpen={modalOpen}
        onModalClose={() => setModalOpen(false)}
      />
    </div>
  );
};

export default Index;
